/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const PADDING_RIGHT = 32;
export const PADDING_LEFT = 32;
